module.exports = __webpack_public_path__ + "fonts/c3965f3.ttf";